module.exports = __webpack_public_path__ + "img/cyhz.7d3c9cb.png";